import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';

export const Loader = (props) => {
  const { t } = useTranslator();
  return (
    <div className={['loader-wrapper', props.fixed === 'no' ? 'no-fixed' : null].join(' ')}>
      <Spinner color="primary">{t('loading.message')}</Spinner>
    </div>
  );
};

Loader.propTypes = {
  fixed: PropTypes.oneOf(['no', null]),
};
Loader.defaultProps = {
  fixed: null,
};

export default Loader;
